export type EpisodeBuildStatus =
  | { phase: 'waiting' }
  | { phase: 'downloading' }
  | { phase: 'queued' }
  | { phase: 'encoding'; percent: number }
  | { phase: 'done' }
  | { phase: 'failed' }

// Keyed by episode id (not tray index) so rows can't misalign if the
// selection ever changes while a build is showing.
export type BuildProgress = {
  building: boolean
  byId: Record<string, EpisodeBuildStatus>
}

export type BuildProgressAction =
  | { type: 'start'; episodeIds: string[] }
  | { type: 'set'; episodeId: string; status: EpisodeBuildStatus }
  | { type: 'reset' }

export const initialBuildProgress: BuildProgress = { building: false, byId: {} }

export function buildProgressReducer(
  state: BuildProgress,
  action: BuildProgressAction,
): BuildProgress {
  switch (action.type) {
    case 'start': {
      const byId: Record<string, EpisodeBuildStatus> = {}
      for (const id of action.episodeIds) byId[id] = { phase: 'waiting' }
      return { building: true, byId }
    }
    case 'set':
      return {
        ...state,
        byId: { ...state.byId, [action.episodeId]: action.status },
      }
    case 'reset':
      return initialBuildProgress
  }
}
